import { render, staticRenderFns } from "./BlockProductList.vue?vue&type=template&id=6cb0c6c6"
import script from "./BlockProductList.vue?vue&type=script&lang=js"
export * from "./BlockProductList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports